/**
 * Overrides de renderizado para `react-markdown` usados en la sección
 * Onboarding (ChapterPage, FAQPage).
 *
 * Regla principal: cualquier enlace externo (http/https/mailto/tel) se
 * abre en pestaña nueva con `rel="noopener noreferrer"` — así el
 * auditor no pierde su sitio en el manual. Los enlaces relativos o
 * ancla se dejan intactos (navegación interna del manual).
 */

import type { AnchorHTMLAttributes } from "react";
import type { Components } from "react-markdown";

const EXTERNAL_PROTOCOL = /^(https?:|mailto:|tel:)/i;

const MarkdownAnchor: React.FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({
  href,
  children,
  ...rest
}) => {
  const isExternal = typeof href === "string" && EXTERNAL_PROTOCOL.test(href);
  if (isExternal) {
    return (
      <a
        {...rest}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }
  return (
    <a {...rest} href={href}>
      {children}
    </a>
  );
};

export const onboardingMarkdownComponents: Components = {
  a: MarkdownAnchor,
};
